/*
  Long Island Pepper Company: taste reaction stories.
  Instagram-style viewer for the real tasting-table reactions. Every section that shows reactions
  (story bubbles, product page row, the reactions page) prints a <script type="application/json"
  data-lipc-taste> blob; this file merges them and drives one shared full-screen viewer.
  Source of truth: execution/lipc-seo-aeo-and-taste-reactions-2026-11-01/theme/assets/
*/
(function () {
  if (window.LipcStories) return;

  var SEEN_KEY = 'lipc_seen_reactions_v1';
  var data = { groups: {}, reels: {}, products: {} };
  var seen = {};
  try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (e) { seen = {}; }

  function saveSeen() { try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch (e) {} }
  function track(name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail)); } catch (e) {}
  }
  function money(cents) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: c }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function loadData() {
    document.querySelectorAll('script[data-lipc-taste]').forEach(function (s) {
      if (s.__lipcRead) return;
      s.__lipcRead = true;
      try {
        var d = JSON.parse(s.textContent);
        (d.groups || []).forEach(function (g) { data.groups[g.key] = g; });
        (d.reels || []).forEach(function (r) { data.reels[r.id] = r; });
        Object.keys(d.products || {}).forEach(function (h) { data.products[h] = d.products[h]; });
      } catch (e) {}
    });
  }

  /* ---------- viewer ---------- */
  var el, video, bars, avatar, label, ctaWrap, muteBtn, quoteEl, titleEl;
  var added = {};
  var seq = [], gi = 0, ri = 0, raf = 0, holding = false, holdTimer = 0, lastCart = null, muted = false, openedAt = 0;

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'lipc-sv';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Taste reactions');
    el.hidden = true;
    el.innerHTML =
      '<div class="lipc-sv__stage">' +
        '<div class="lipc-sv__frame">' +
          '<video class="lipc-sv__video" playsinline webkit-playsinline preload="auto"></video>' +
          '<div class="lipc-sv__shade"></div>' +
          '<div class="lipc-sv__top">' +
            '<div class="lipc-sv__bars"></div>' +
            '<div class="lipc-sv__head">' +
              '<span class="lipc-sv__avatar" aria-hidden="true"></span>' +
              '<div class="lipc-sv__who"><strong class="lipc-sv__label"></strong><span class="lipc-sv__title"></span></div>' +
              '<button type="button" class="lipc-sv__icon lipc-sv__mute" aria-label="Mute"></button>' +
              '<button type="button" class="lipc-sv__icon lipc-sv__close" aria-label="Close">' +
                '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="lipc-sv__tap lipc-sv__tap--prev" aria-label="Previous reaction"></button>' +
          '<button type="button" class="lipc-sv__tap lipc-sv__tap--next" aria-label="Next reaction"></button>' +
          '<div class="lipc-sv__bottom">' +
            '<p class="lipc-sv__quote"></p>' +
            '<div class="lipc-sv__cta"></div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="lipc-sv__nav lipc-sv__nav--prev" aria-label="Previous">&#8249;</button>' +
        '<button type="button" class="lipc-sv__nav lipc-sv__nav--next" aria-label="Next">&#8250;</button>' +
      '</div>';
    document.body.appendChild(el);
    video = el.querySelector('video');
    bars = el.querySelector('.lipc-sv__bars');
    avatar = el.querySelector('.lipc-sv__avatar');
    label = el.querySelector('.lipc-sv__label');
    titleEl = el.querySelector('.lipc-sv__title');
    quoteEl = el.querySelector('.lipc-sv__quote');
    ctaWrap = el.querySelector('.lipc-sv__cta');
    muteBtn = el.querySelector('.lipc-sv__mute');

    el.querySelector('.lipc-sv__close').addEventListener('click', close);
    el.querySelector('.lipc-sv__nav--prev').addEventListener('click', prev);
    el.querySelector('.lipc-sv__nav--next').addEventListener('click', next);
    muteBtn.addEventListener('click', function () { setMuted(!muted); });
    el.addEventListener('click', function (e) { if (e.target === el || e.target.classList.contains('lipc-sv__stage')) close(); });

    var tapPrev = el.querySelector('.lipc-sv__tap--prev'), tapNext = el.querySelector('.lipc-sv__tap--next');
    [tapPrev, tapNext].forEach(function (b) {
      b.addEventListener('pointerdown', function () {
        holdTimer = setTimeout(function () { holding = true; video.pause(); el.classList.add('is-held'); }, 220);
      });
      b.addEventListener('pointerup', function () {
        clearTimeout(holdTimer);
        if (holding) { holding = false; el.classList.remove('is-held'); video.play().catch(function () {}); return; }
        if (b === tapPrev) prev(); else next();
      });
      b.addEventListener('pointercancel', function () { clearTimeout(holdTimer); if (holding) { holding = false; el.classList.remove('is-held'); video.play().catch(function () {}); } });
      b.addEventListener('click', function (e) { e.preventDefault(); });
    });

    var sy = null, sx = null;
    el.addEventListener('touchstart', function (e) { sy = e.touches[0].clientY; sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (sy === null) return;
      var dy = e.changedTouches[0].clientY - sy, dx = e.changedTouches[0].clientX - sx;
      if (dy > 90 && Math.abs(dx) < 70) close();
      else if (Math.abs(dx) > 70 && Math.abs(dy) < 60) { if (dx < 0) nextGroup(); else prevGroup(); }
      sy = sx = null;
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === ' ') { e.preventDefault(); if (video.paused) video.play().catch(function () {}); else video.pause(); }
    });

    video.addEventListener('ended', next);
    video.addEventListener('error', function () { setTimeout(next, 400); });
    video.addEventListener('waiting', function () { el.classList.add('is-loading'); });
    video.addEventListener('playing', function () { el.classList.remove('is-loading'); });
  }

  function setMuted(m) {
    muted = m;
    video.muted = m;
    muteBtn.setAttribute('aria-label', m ? 'Turn sound on' : 'Mute');
    muteBtn.innerHTML = m
      ? '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M17 9l5 6M22 9l-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      : '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  }

  function group() { return seq[gi]; }
  function reel() { var g = group(); return g && data.reels[g.reels[ri]]; }

  function renderBars() {
    var g = group();
    bars.innerHTML = g.reels.map(function (_, i) {
      return '<span class="lipc-sv__bar' + (i < ri ? ' is-done' : '') + '"><i></i></span>';
    }).join('');
  }

  function ctaFor(r, g) {
    var handle = (g.product) || (r.products && r.products[0]);
    var p = handle && data.products[handle];
    if (p && p.variant && p.available) {
      var done = added[p.variant];
      return '<div class="lipc-sv__product">' +
          (p.image ? '<img src="' + p.image + '" alt="" width="44" height="44">' : '') +
          '<a href="' + p.url + '" class="lipc-sv__pname"><strong>' + p.title + '</strong><span>' + money(p.price) + '</span></a>' +
          (done ? '<span class="lipc-sv__add is-added">Added</span><a class="lipc-sv__checkout" href="' + ((window.routes && routes.cart_url) || '/cart') + '">View cart</a>'
                : '<button type="button" class="lipc-sv__add" data-variant="' + p.variant + '" data-handle="' + handle + '">Add to cart</button>') +
        '</div>';
    }
    if (p) return '<a class="lipc-sv__link" href="' + p.url + '">See ' + p.title + '</a>';
    if (g.cta_url) return '<a class="lipc-sv__link" href="' + g.cta_url + '">' + (g.cta_label || 'Shop the sauces') + '</a>';
    return '<a class="lipc-sv__link" href="/collections/all">Shop the sauces</a>';
  }

  function show() {
    var g = group(), r = reel();
    if (!g || !r) { close(); return; }
    cancelAnimationFrame(raf);
    renderBars();
    avatar.style.backgroundImage = g.cover ? 'url("' + g.cover + '")' : '';
    label.textContent = g.label;
    titleEl.textContent = r.title || '';
    quoteEl.textContent = r.quote ? '“' + r.quote + '”' : '';
    quoteEl.hidden = true;
    ctaWrap.innerHTML = ctaFor(r, g);
    var add = ctaWrap.querySelector('.lipc-sv__add');
    if (add) add.addEventListener('click', addToCart);
    video.poster = r.poster || '';
    video.src = r.video;
    video.muted = muted;
    var p = video.play();
    if (p && p.catch) p.catch(function () { setMuted(true); video.play().catch(function () {}); });
    seen[r.id] = 1; saveSeen(); markSeen();
    track('lipc_reaction_view', { reel: r.id, group: g.key });
    // warm the next file
    var nx = g.reels[ri + 1] ? data.reels[g.reels[ri + 1]] : (seq[gi + 1] && data.reels[seq[gi + 1].reels[0]]);
    if (nx && nx.video) { var l = document.createElement('link'); l.rel = 'preload'; l.as = 'video'; l.href = nx.video; document.head.appendChild(l); setTimeout(function () { l.remove(); }, 15000); }
    tick();
  }

  function tick() {
    var bar = bars.children[ri] && bars.children[ri].firstChild;
    if (bar && video.duration) bar.style.transform = 'scaleX(' + Math.min(1, video.currentTime / video.duration) + ')';
    raf = requestAnimationFrame(tick);
  }

  function next() { var g = group(); if (!g) return; if (ri < g.reels.length - 1) { ri++; show(); } else nextGroup(); }
  function prev() { if (ri > 0) { ri--; show(); } else if (gi > 0) { gi--; ri = 0; show(); } else { video.currentTime = 0; } }
  function nextGroup() { if (gi < seq.length - 1) { gi++; ri = 0; show(); } else close(); }
  function prevGroup() { if (gi > 0) { gi--; ri = 0; show(); } }

  function open(groupKeys, startKey, startReel) {
    loadData();
    build();
    seq = groupKeys.map(function (k) { return typeof k === 'string' ? data.groups[k] : k; }).filter(function (g) { return g && g.reels && g.reels.length; });
    if (!seq.length) return;
    gi = Math.max(0, seq.findIndex(function (g) { return g.key === startKey; }));
    ri = startReel ? Math.max(0, seq[gi].reels.indexOf(startReel)) : 0;
    if (!startReel) { // resume at the first unseen reel, like Instagram
      var first = seq[gi].reels.findIndex(function (id) { return !seen[id]; });
      ri = first > 0 ? first : 0;
    }
    el.hidden = false;
    openedAt = Date.now();
    document.documentElement.classList.add('lipc-sv-open');
    setMuted(false);
    show();
    track('lipc_reactions_open', { group: seq[gi].key });
  }

  function close() {
    if (!el || el.hidden) return;
    cancelAnimationFrame(raf);
    video.pause();
    video.removeAttribute('src');
    video.load();
    el.hidden = true;
    document.documentElement.classList.remove('lipc-sv-open');
    track('lipc_reactions_close', { seconds: Math.round((Date.now() - openedAt) / 1000) });
    var drawer = document.querySelector('cart-drawer');
    if (lastCart && drawer && drawer.renderContents) {
      try { drawer.renderContents(lastCart); } catch (e) {}
    }
    lastCart = null;
  }

  function addToCart(e) {
    var b = e.currentTarget;
    if (b.disabled) return;
    b.disabled = true;
    b.textContent = 'Adding';
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.variant), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message);
      lastCart = res;
      added[b.dataset.variant] = 1;
      if (drawer) drawer.classList.remove('is-empty');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && res.sections && res.sections['cart-icon-bubble']) {
        var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lipc-stories', productVariantId: Number(b.dataset.variant), cartData: res }); } catch (er) {}
      b.textContent = 'Added';
      b.classList.add('is-added');
      var go = document.createElement('a');
      go.href = (window.routes && routes.cart_url) || '/cart';
      go.className = 'lipc-sv__checkout';
      go.textContent = 'View cart';
      b.after(go);
      track('lipc_reaction_add_to_cart', { handle: b.dataset.handle, reel: (reel() || {}).id });
    }).catch(function () {
      b.disabled = false;
      b.textContent = 'Try again';
    });
  }

  /* ---------- bubbles + cards ---------- */
  function markSeen() {
    document.querySelectorAll('[data-lipc-story]').forEach(function (b) {
      var g = data.groups[b.getAttribute('data-lipc-story')];
      if (!g) return;
      var all = g.reels.every(function (id) { return seen[id]; });
      b.classList.toggle('is-seen', all);
    });
  }

  function bind(root) {
    loadData();
    (root || document).querySelectorAll('[data-lipc-story]').forEach(function (b) {
      if (b.__lipc) return; b.__lipc = 1;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var strip = b.closest('[data-lipc-story-order]');
        var order = strip ? strip.getAttribute('data-lipc-story-order').split(',') : [b.getAttribute('data-lipc-story')];
        open(order, b.getAttribute('data-lipc-story'));
      });
    });
    (root || document).querySelectorAll('[data-lipc-reel]').forEach(function (c) {
      if (c.__lipc) return; c.__lipc = 1;
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var host = c.closest('[data-lipc-reel-set]');
        var ids = host.getAttribute('data-lipc-reel-set').split(',');
        var g = { key: host.getAttribute('data-lipc-set-key') || 'set', label: host.getAttribute('data-lipc-set-label') || 'Taste reactions',
                  cover: host.getAttribute('data-lipc-set-cover') || '', product: host.getAttribute('data-lipc-set-product') || '', reels: ids };
        open([g], g.key, c.getAttribute('data-lipc-reel'));
      });
    });
    markSeen();
  }

  window.LipcStories = { open: open, close: close, bind: bind };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
